<template>
    <v-form ref="addCompanyBranchForm"
            :disabled="isFormDisabled()"
    >
        <v-row>
            <v-col cols="12" sm="6" md="2" lg="2" xl="1">
                <v-text-field
                    v-model="details.name"
                    label="Nazwa oddziału"
                    :aria-required="false"
                    :counter="254"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2" xl="1">
                <v-text-field
                    v-model="details.partnerPhone"
                    label="Telefon na stronie partnera"
                    :aria-required="false"
                    :counter="20"
                />
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2" xl="1">
                <v-text-field
                    v-model="details.phone"
                    label="Telefon"
                    :aria-required="false"
                    :counter="20"
                />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" xl="2">
                <v-text-field
                    v-model="details.email"
                    label="Email"
                    :aria-required="false"
                    :counter="254"
                />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" xl="2">
                <v-text-field
                    v-model="details.address.address"
                    label="Ulica"
                    :aria-required="false"
                    :counter="100"
                />
            </v-col>
            <v-col cols="12" sm="3" md="4" lg="3" xl="1">
                <v-text-field
                    v-model="details.address.postalCode"
                    label="Kod pocztowy"
                    :aria-required="false"
                    :counter="10"
                />
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="3" xl="2">
                <v-text-field
                    v-model="details.address.city"
                    label="Miejscowość"
                    :aria-required="false"
                    :counter="100"
                />
            </v-col>
            <v-col cols="12" sm="5" md="4" lg="3" xl="2">
                <v-select
                    v-model="details.address.region"
                    label="Województwo"
                    :items="regions"
                    item-value="value"
                    item-text="text"
                ></v-select>
            </v-col>
            <v-col cols="6" sm="2" md="2" lg="2">
                <div class="pb-0 disabled-label">
                    Transport:
                </div>
                <v-switch
                    v-model="details.transport"
                    class="mt-0 pt-0"
                    :label="details.transport ? 'Tak' : 'Nie'"
                ></v-switch>
            </v-col>
            <v-col cols="6" sm="2" md="2" lg="1">
                <div class="pb-0 disabled-label">
                    Od firm:
                </div>
                <v-switch
                    v-model="details.fromCompanies"
                    class="mt-0 pt-0"
                    :label="details.fromCompanies ? 'Tak' : 'Nie'"
                />
            </v-col>
            <v-col cols="12" sm="4" md="2" lg="">
                <div class="pb-0 disabled-label">
                    Od osób fizycznych:
                </div>
                <v-switch
                    v-model="details.fromNaturalPersons"
                    class="mt-0 pt-0"
                    :label="details.fromNaturalPersons ? 'Tak' : 'Nie'"
                ></v-switch>
            </v-col>
            <v-col cols="6" sm="2" md="2" lg="">
                <div class="pb-0 disabled-label">
                    Hurt:
                </div>
                <v-switch
                    v-model="details.wholesale"
                    class="mt-0 pt-0"
                    :label="details.wholesale ? 'Tak' : 'Nie'"
                />
            </v-col>
            <v-col cols="6" sm="2" md="2" lg="">
                <div class="pb-0 disabled-label">
                    Detal:
                </div>
                <v-switch
                    v-model="details.retail"
                    class="mt-0 pt-0"
                    :label="details.retail ? 'Tak' : 'Nie'"
                />
            </v-col>
            <v-col cols="6" sm="2" md="2" lg="2">
                <div class="pb-0 disabled-label">
                    Główny:
                </div>
                <v-switch
                    v-model="details.isMain"
                    class="mt-0 pt-0"
                    :label="details.isMain ? 'Tak' : 'Nie'"
                    hint="Ta informacja jest zapisywana po stronie firmy, nie oddziału."
                    :persistent-hint="true"
                ></v-switch>
            </v-col>
            <v-col cols="6" sm="2" md="2" lg="1">
                <div class="pb-0 disabled-label">
                    Aktywny:
                </div>
                <v-switch
                    v-model="details.isActive"
                    class="mt-0 pt-0"
                    :label="details.isActive ? 'Tak' : 'Nie'"
                    :persistent-hint="true"
                ></v-switch>
            </v-col>
            <v-col cols="12">
                <v-select
                    v-if="details.companyId"
                    v-model="details.users"
                    :items="users"
                    :item-text="item => (item.name ? (item.name + ' ') : '') + (item.surname ? item.surname + ' - ' : '') + item.email"
                    item-value="id"
                    multiple
                    label="Użytkownicy"
                    required
                ></v-select>
                <p v-if="!details.companyId"><strong>Przypisz firmę do modułu cennikowego aby wybrać użytkowników.</strong></p>
            </v-col>
            <v-col cols="12">
                <label>Krótki opis <span @click="showRawDescription = !showRawDescription"
                                  v-html="showRawDescription ? '(pokaż edytor)' : '(pokaż źródło)'"></span></label>
                <ckeditor
                    v-if="!showRawDescription"
                    :editor="editor"
                    v-model="details.shortDescription"
                    :config="editorConfig"
                ></ckeditor>

                <v-textarea
                    v-if="showRawDescription"
                    v-model="details.shortDescription"
                    rows="20"
                    label="Krótki opis"
                />
            </v-col>
            <v-col cols="12">
                <label>Opis <span @click="showRawDescription = !showRawDescription"
                                  v-html="showRawDescription ? '(pokaż edytor)' : '(pokaż źródło)'"></span></label>
                <ckeditor
                    v-if="!showRawDescription"
                    :editor="editor"
                    v-model="details.description"
                    :config="editorConfig"
                ></ckeditor>

                <v-textarea
                    v-if="showRawDescription"
                    v-model="details.description"
                    rows="20"
                    label="Opis"
                />
            </v-col>
          <v-col cols="12">
            <label>Warunki wynajmu <span @click="showRawDescription = !showRawDescription"
                                         v-html="showRawDescription ? '(pokaż edytor)' : '(pokaż źródło)'"></span></label>
            <ckeditor
                v-if="!showRawDescription"
                :editor="editor"
                v-model="details.rentalConditions"
                :config="editorConfig"
            ></ckeditor>

            <v-textarea
                v-if="showRawDescription"
                v-model="details.rentalConditions"
                rows="20"
                label="Warunki wynajmu"
            />
          </v-col>
            <v-col cols="12">
                <v-textarea
                    v-model="details.www"
                    label="WWW"
                    rows="3"
                    :aria-required="false"
                    :counter="65535"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="details.type"
                    label="Rodzaj"
                    :aria-required="false"
                    :counter="20"
                />
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="getLocationTypes()"
                  v-model="details.location"
                  label="Lokalizacja odbioru"
                  item-value="key"
                  item-text="value"
                  solo
                  class="wastemaster-input-elevation"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="details.additionalLocation" label="Dokładna lokalizacja odiboru"></v-textarea>
            </v-col>
            <v-col cols="12">
                <v-textarea
                    v-model="details.map"
                    label="Mapa"
                    rows="3"
                    :aria-required="false"
                    :counter="65535"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="details.minDistance"
                    label="Wykluczony dystans w km"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="details.distance"
                    label="Obsługiwany dystans w km"
                />
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <label>Godziny otwarcia</label>
          </v-col>
        </v-row>
        <v-row v-for="workingHour in details.workingHours" :key="workingHour.id">
          <v-col cols="12">
            {{ weekDayLabels[workingHour.dayOfWeek] }}
          </v-col>
          <v-col cols="3">
            <v-switch
                v-model="workingHour.enabled"
                :label="workingHour.enabled ? 'Otwarte' : 'Zamknięte'"/>
          </v-col>
          <v-col cols="3">
            <v-text-field
                v-model="workingHour.startTime"
                label="Godzina otwarcia"
                type="time"
                :disabled="!workingHour.enabled"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
                v-model="workingHour.endTime"
                label="Godzina zamknięcia"
                type="time"
                :disabled="!workingHour.enabled"
            />
          </v-col>
        </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn
              :disabled="saving"
              @click="save"
              v-if="isIdle()"
          >
            Zapisz
            <v-icon size="24" right>
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
</template>

<script>
import api from "@/services/api";
import {getItems as getRegionItems} from '@/enums/RegionCode';
import ClassicEditor from '../../utils/ckeditor5/build/ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import UploadAdapter from "../../services/UploadAdapter";
import locationTypeMixin from "@/mixins/locationTypeMixin";

export default {
    props: {
        companyId: {
            type: [String],
            required: true,
        },
        id: {
            type: [String],
            required: false,
            default: null,
        },
    },
    mixins: [locationTypeMixin],
    components: {ckeditor: CKEditor.component},
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                extraPlugins: [this.uploader],
                companyId: this.companyId,
            },
            weekDayLabels: {
                1: 'Poniedziałek',
                2: 'Wtorek',
                3: 'Środa',
                4: 'Czwartek',
                5: 'Piątek',
                6: 'Sobota',
                7: 'Niedziela',
            },
            default: {
                name: '',
                shortDescription: '',
                description: '',
                phone: '',
                email: '',
                www: '',
                additionalLocation: '',
                location: '',
                address: {
                    address: '',
                    postalCode: '',
                    city: '',
                    region: '',
                },
                transport: false,
                fromNaturalPersons: false,
                fromCompanies: false,
                wholesale: false,
                retail: false,
                type: '',
                isMain: false,
                isActive: true,
            },
            details: {
                name: '',
                shortDescription: '',
                rentalConditions: '',
                description: '',
                phone: '',
                email: '',
                www: '',
                additionalLocation: '',
                location: '',
                address: {
                    address: '',
                    postalCode: '',
                    city: '',
                    region: '',
                },
                transport: false,
                fromNaturalPersons: false,
                fromCompanies: false,
                wholesale: false,
                retail: false,
                type: '',
                isMain: false,
                isActive: true,
                distance: null,
                minDistance: null,
            },
            label: {},
            regions: [
                ...getRegionItems(),
            ],
            rules: {},
            loading: false,
            saving: false,
            showRawDescription: false,
            users: [],
        };
    },
    computed: {},
    created() {
        if (this.id) {
            this.get();
        }
    },
    methods: {
        isIdle() {
            return !this.loading && !this.saving;
        },
        isFormDisabled() {
            return !this.isIdle();
        },
        isEditForm() {
            return !!this.id;
        },
        add() {
            if (this.saving) {
                return;
            }

            this.saving = true;
            const self = this;
            let details = {
                companyId: this.companyId,
                ...this.details,
            };

            delete details.createdAt;
            delete details.updatedAt;

            api.post(`/api/price-list/company-branch`, details)
                .then((response) => {
                    this.details = response.data;
                    this.$root.$emit('notifySuccess', {
                        html: 'Oddział został zapisany.',
                        callback: () => {
                            // The following setTimeout() call is required to render the success message for the user before
                            // displaying the built-in prompt window.
                            setTimeout(function () {
                                self.saving = false;
                                self.askForNextBranch();
                            }, 500);
                        }
                    });
                })
                .catch((error) => {
                    this.saving = false;
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się dodać oddziału.',
                        error,
                    });
                });
        },
        get() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            api.get(`/api/price-list/company-branch/${this.id}`)
                .then((response) => {
                    this.details = response.data;

                    const params = {
                        companyId: this.details.companyId,
                    };

                    api
                        .get("/api/users", {params})
                        .then((response) => {
                            this.users = response.data.items;
                        })
                        .catch((error) => {
                            this.$root.$emit("notifyError", {
                                html: "Nie udało się pobrać listy użytkowników.",
                                error,
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się pobrać danych oddziału.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        save() {
            if (this.saving) {
                return;
            }

            if (this.isEditForm()) {
                this.update();
            } else {
                this.add();
            }
        },
        update() {
            if (this.saving) {
                return;
            }

            this.saving = true;
            const self = this;
            let details = {...this.details};

            delete details.id;
            delete details.createdAt;
            delete details.updatedAt;

            api.put(`/api/price-list/company-branch/${this.id}`, details)
                .then(() => {
                    this.get();

                    this.$root.$emit('notifySuccess', {
                        html: 'Oddział został zapisany.',
                        callback: () => {
                            // The following setTimeout() call is required to render the success message for the user before
                            // displaying the built-in prompt window.
                            setTimeout(function () {
                                self.saving = false;
                            }, 500);
                        }
                    });
                })
                .catch((error) => {
                    this.saving = false;
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zaktualizować danych oddziału.',
                        error,
                    });
                });
        },
        askForNextBranch() {
            if (confirm('Chcesz dodać kolejny oddział?')) {
                this.clear();
            } else {
                this.$router
                    .push({name: 'price-list-company-details', params: {id: this.companyId}})
                    .catch(() => {
                    });
            }
        },
        clear() {
            this.details.name = this.default.name;
            this.details.description = this.default.description;
            this.details.phone = this.default.phone;
            this.details.email = this.default.email;
            this.details.www = this.default.www;
            this.details.address = {...this.default.address};
            this.details.transport = this.default.transport;
            this.details.fromNaturalPersons = this.default.fromNaturalPersons;
            this.details.fromCompanies = this.default.fromCompanies;
            this.details.wholesale = this.default.wholesale;
            this.details.retail = this.default.retail;
            this.details.type = this.default.type;
            this.details.isMain = this.default.isMain;
            this.details.additionalLocation = this.default.additionalLocation;
            this.details.location = this.default.location;
        },
        uploader(editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return new UploadAdapter(editor.config.get('companyId'), loader);
            };
        },
    },
}
</script>